import React from "react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";

function TimeButton({ active, onClick, icon, label, testId, compact }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      style={{
        padding: compact ? "5px 10px" : "6px 14px",
        borderRadius: 999,
        border: "none",
        cursor: "pointer",
        backgroundColor: active ? COLORS.gold : "transparent",
        color: active ? COLORS.navyDeep : COLORS.ivory,
        fontFamily: fontSerif,
        fontSize: compact ? 11 : 12,
        letterSpacing: 1.5,
        textTransform: "uppercase",
        fontWeight: active ? 700 : 500,
        display: "flex",
        alignItems: "center",
        gap: 6,
        transition: "all .2s",
      }}
    >
      <span style={{ fontSize: compact ? 12 : 13, color: active ? COLORS.navyDeep : COLORS.gold }}>
        {icon}
      </span>
      {label}
    </button>
  );
}

export default function TimeControls({ timeMode, autoLabel, setTimeMode, inline = false, compact = false }) {
  const statusText =
    timeMode === "auto"
      ? `Auto · ${autoLabel}`
      : timeMode === "day"
      ? "Day"
      : "Night";

  const wrapperStyle = inline
    ? {
        display: "flex",
        alignItems: "center",
        gap: compact ? 6 : 10,
        pointerEvents: "auto",
        color: COLORS.ivory,
        fontFamily: fontSerif,
        flexWrap: "wrap",
        justifyContent: "flex-end",
      }
    : {
        position: "absolute",
        top: 104,
        right: 24,
        display: "flex",
        alignItems: "center",
        gap: 10,
        pointerEvents: "auto",
        color: COLORS.ivory,
        fontFamily: fontSerif,
      };

  return (
    <div data-testid="zone-time-toggle" style={wrapperStyle}>
      <div
        data-testid="zone-time-status"
        style={{
          fontSize: compact ? 9 : 10,
          letterSpacing: 3,
          color: COLORS.gold,
          textTransform: "uppercase",
          padding: compact ? "5px 10px" : "6px 12px",
          ...pill,
        }}
      >
        {statusText}
      </div>
      <div style={{ display: "flex", gap: compact ? 4 : 6, padding: compact ? 3 : 4, ...pill }}>
        <TimeButton
          active={timeMode === "auto"}
          onClick={() => setTimeMode("auto")}
          icon="◐"
          label="Auto"
          testId="zone-time-auto"
          compact={compact}
        />
        <TimeButton
          active={timeMode === "day"}
          onClick={() => setTimeMode("day")}
          icon="☀"
          label="Day"
          testId="zone-time-day"
          compact={compact}
        />
        <TimeButton
          active={timeMode === "night"}
          onClick={() => setTimeMode("night")}
          icon="☾"
          label="Night"
          testId="zone-time-night"
          compact={compact}
        />
      </div>
    </div>
  );
}
